<template>
  <global-events v-bind="$attrs" :filter="filterKeyboardEvents" />
</template>

<script lang="ts" setup>
import { GlobalEvents } from 'vue-global-events'

const props = defineProps<{
  noFiltering?: boolean
}>()

/**
 * The filtering is used so that different text inputs (e.g. comment editor, inputs in the Filter modal etc)
 * wouldn't trigger a random sort (R) or navigating to the next ticket (vim shortcuts for j, k, arrows etc.)
 */
const filterKeyboardEvents = (event) => {
  if (props.noFiltering) return true

  const INPUT_ELEMENTS = ['INPUT', 'TEXTAREA'] as const
  const targetIsInput = INPUT_ELEMENTS.includes(event.target.tagName)
  const shadowRootActiveElementIsInput = INPUT_ELEMENTS.includes(event.target?.shadowRoot?.activeElement?.tagName)

  const textInput = targetIsInput || shadowRootActiveElementIsInput || event.target.contentEditable === 'true'
  return event.metaKey || event.ctrlKey || !textInput
}
</script>
